(function($, Drupal, once, cookies) {

    //copy raf code from url and save in clipboard
    Drupal.behaviors.trackCodeHandler = {
        attach: function(context, settings) {
            once('trackCodeHandler', 'html', context).forEach(function(element) {
                $(document).ready(function() {

                    let params = new URLSearchParams();

                    // handle referral code
                    handleRafCode(params);
                    // handle channel code
                    handleChannelCode(params);
                    // handle source code
                    handleSourceCode(params, cookies);

                    // prepare text for clipboard
                    if ( (cookies.get("clipboard") != "copied") && (params.toString().length > 0) ) {
                        let clipboard = new ClipboardJS('a', {
                            text: function(trigger) {
                                return decodeURIComponent(params.toString());
                            }
                        });
                        // write to cookie on clipboard is written
                        clipboard.on('success', function(e) {
                            cookies.set("clipboard", "copied");
                        });                        
                    }

                    // rewrite download URL
                    rewriteDownloadURL(params);

                });
            })
        }
    };

    //misc js
    $(document).ready(function() {
        const pageTitle = document.title;
      
        $('img').each(function() {
          const altText = $(this).attr('alt');
          if (!altText) {
            $(this).attr('alt', pageTitle);
          }
        });
    });

})(jQuery, Drupal, once, window.Cookies);

// rewrite download URL
function rewriteDownloadURL(params) {
    var domain = window.location.hostname;
    var brand = getSourceFromMetatag();
    var userportal = "https://user." + domain.split('.').slice(-2).join('.') + (params.toString() ? "/?" + params.toString() : '');
    jQuery(".app-dl-url").each(function () {
        if (brand) {
            let downloadPath = "https://" + domain + "/d/" + brand + "/" + brand;
            var ios = "https://l.ahajsq.com/seo/d/ios/install";
            var android = downloadPath + "_android.apk";
            var win = downloadPath + "_win.exe";
            var macos = downloadPath + "_mac.pkg";

            if (jQuery(this).hasClass("ios-dl-url") && jQuery(this).attr("href") && jQuery(this).attr("href").includes("user.")) {
                jQuery(this).attr("href", ios)
            } else if (jQuery(this).hasClass("android-dl-url")) {
                jQuery(this).attr("href", android)
            } else if (jQuery(this).hasClass("windows-dl-url")) {
                jQuery(this).attr("href", win)
            } else if (jQuery(this).hasClass("macos-dl-url")) {
                jQuery(this).attr("href", macos)
            }
        }
    });

    jQuery("header .btn").each(function () {
        if (brand && jQuery(this).attr("href") && jQuery(this).attr("href").includes("user.")) {
            jQuery(this).attr("href", userportal);
        }
    });
}